import Pusher from './pusher'
import store from '@/store'
import Vue from 'vue'

/**
 * Presence Helper
 */
class Presence {
  constructor () {
    this.pusher = new Pusher()
    this.channels = {}
  }

  subscribe = function (channelName) {
    const vm = this

    // Tell vuex we are subscribing
    store.dispatch('presence/subscribe', channelName)
      .then(response => {
        Vue.set(vm.channels, channelName, vm.pusher.subscribe(channelName))

        vm.channels[channelName].bind('pusher:subscription_succeeded', function (members) {
          store.dispatch('presence/subscription_succeeded', { channelName: channelName, members: members })
        })

        vm.channels[channelName].bind('pusher:subscription_error', function (status) {
          store.dispatch('presence/subscription_error', { channelName: channelName, status: status })
        })

        vm.channels[channelName].bind('pusher:member_added', function (member) {
          store.dispatch('presence/member_added', { channelName: channelName, member: member })
        })

        vm.channels[channelName].bind('pusher:member_removed', function (member) {
          store.dispatch('presence/member_removed', { channelName: channelName, member: member })
        })
      })
      .catch(error => {
        console.log('Failed to subscribe in vuex')
        console.log(error)
      })
  }

  unsubscribe = function (channelName) {
    const vm = this

    // Tell vuex we are subscribing
    store.dispatch('presence/unsubscribe', channelName)
      .then(() => {
        // Send unsubscribe event
        vm.pusher.unsubscribe(channelName)

        // Clean up
        Vue.delete(vm.channels, channelName)
      })
  }
}

export default () => {
  const instance = new Presence()

  return instance
}



// WEBPACK FOOTER //
// ./src/plugins/presence.js